export default __webpack_public_path__ + "static/media/ready.f6dde30e.mp3";